import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export const StyledSwitchGroupTitle = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 11px;
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  margin-left: ${({ theme }) => theme.spacing(1)};
  text-transform: uppercase;
`;
